<template>
    <div>
        <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
            <NavBar title="添加配件"/>
            <Field
                    clearable
                    v-model="partName"
                    label="配件"
                    placeholder="请选择配件"
                    readonly
                    required
                    right-icon="arrow-down"
                    @click="partPanel = true"
                    :rules="[{ required: true, message: '配件必选' }]"
            />
            <Field
                    clearable
                    required
                    v-model="count"
                    label="数量"
                    placeholder="请输入数量"
                    :rules="[{ required: true, message: '数量不为空' }]"
            />
            <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确认保存</Button>
        </Popup>
        <SelectProductPartPopup :parts="parts" :show="partPanel" @cancel="partPanel = false"
                                @ok="selectPart"/>
    </div>
</template>

<script>
    import {Button, Field, Form, NavBar, Popup} from "vant"
    import SelectProductPartPopup from "@/components/SelectPopup/SelectProductPartPopup";

    export default {
        components: {Popup, Form, Field, Button, NavBar, SelectProductPartPopup},
        props: {
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false}
        },
        data() {
            return {
                deviceId: this.$route.params.id,
                count: null,
                partName: null,
                partId: null,
                popupShow: false,
                partPanel: false,
                parts: []
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getProductPart()
        },
        methods: {
            submit() {
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.device.part.submit({
                    deviceId: this.deviceId,
                    count: this.count,
                    productPartId: this.partId
                }).then(res => {
                    this.$toast.clear();
                    if (res) {
                        this.$toast.success("提交成功")
                        this.popupShow = false;
                        this.$emit("onRefresh")
                    } else {
                        this.$toast.fail(res.message)
                    }
                })
            },
            selectPart(data) {
                console.error('选择配件', data)
                this.partName = `${data.name}(${data.model})`;
                this.partId = data.id;
                this.partPanel = false;
            },
            getProductPart() {
                this.$http.tokiot.device.product.part.list({id: this.deviceId})
                    .then(parts => {
                        if (parts) {
                            this.parts = parts;
                        }
                    })
            },
            close() {
                this.$emit('panel', this.type,)
            },
        },
        watch: {
            show(show) {
                this.popupShow = show
            }
        }
    }
</script>

<style scoped>

</style>